import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import type { ReactNode } from "react";
import { gaps } from "../../spacing";
import { SectionLabel } from "../../data-display/SectionLabel";

interface SectionProps {
  title?: ReactNode;
  /** Optional right-aligned element on the title row, e.g. a count. */
  action?: ReactNode;
  gap?: number;
  children: ReactNode;
}

const TitleRow = styled(Stack)({
  justifyContent: "space-between",
  alignItems: "baseline",
});

/** A labelled, consistently-gapped block of page content. Renders as a `<section>`. */
export function Section({ title, action, gap = gaps.tight, children }: SectionProps) {
  return (
    <Stack component="section" gap={gap}>
      {(title || action) && (
        <TitleRow direction="row">
          {title ? <SectionLabel>{title}</SectionLabel> : null}
          {action}
        </TitleRow>
      )}
      {children}
    </Stack>
  );
}
